import { Item } from "@aitisal/contracts/restaurant/menu";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";
import Loader from "../../../components/Loader";
import { ThemeSlot } from "../../../themes/slots";
import { useMenuAggregate } from "../../../hooks/useMenuAggregate";

export const Route = createFileRoute("/c/_menuLayout/item/$itemId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { itemId } = Route.useParams();

  const { data: menusData, isLoading: isMenuLoading } = useMenuAggregate();

  const navigate = useNavigate();

  const selectedItem = useMemo(() => {
    if (!menusData?.menus || !itemId) return null;

    for (const menu of menusData.menus) {
      for (const section of menu.sections || []) {
        const item = section.items?.find((item: Item) => item.itemId === itemId);
        if (item) return item;
      }
    }
    return null;
  }, [menusData, itemId]);

  useEffect(() => {
    if (menusData && itemId && !selectedItem) {
      navigate({
        to: "/c",
        search: (prev) => prev,
      });
    }
  }, [menusData, itemId, selectedItem, navigate]);

  const closeModal = () => {
    navigate({
      to: "/c",
      search: (prev) => prev,
      resetScroll: false,
    });
  };

  if (isMenuLoading) {
    return <Loader />;
  }

  return (
    <ThemeSlot
      slot="itemDetails"
      selectedItem={selectedItem}
      openedModal={true}
      closeModal={closeModal}
    />
  );
}
